<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Milestone</h1>
    <line-chart class="mb-10" v-for="(vital_data, index) in this.vital_datas()" :chartData="this.chartData(vital_data)" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import LineChart from '@/Shared/LineChart'

export default {
  inject: ['patient', 'vital_datas'],
  components: {
    LineChart,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {

    }
  },
  methods: {
    chartData(vital_data) {
      let label;
      let labels = [];
      let values = [];
      for(let index in vital_data) {
        let v = vital_data[index];
        label = v.goal_name;
        labels.push(this.$filters.formatDateTime(v.date));
        values.push(v.value);
      }
      return {
        labels: labels,
        datasets: [
          {
            label: label,
            backgroundColor: '#1E3A8A',
            data: values
          }
        ]
      }
    }
  },
  mounted() {

  },
}
</script>